import { useI18n } from "@/context/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="mt-12 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-8 text-sm text-slate-600">
        <div className="grid gap-4 md:grid-cols-3">
          <div>
            <div className="font-heading font-bold text-slate-900">{t("footer.notice")}</div>
            <p className="mt-2 leading-relaxed">
              {t("footer.noticeBody")} <span className="font-semibold text-slate-900">{t("footer.noticeStrong")}</span>
            </p>
          </div>
          <div>
            <div className="font-heading font-bold text-slate-900">{t("footer.data")}</div>
            <p className="mt-2 leading-relaxed">{t("footer.dataBody")}</p>
          </div>
          <div>
            <div className="font-heading font-bold text-slate-900">{t("footer.emergency")}</div>
            <p className="mt-2 leading-relaxed">{t("footer.emergencyBody")}</p>
          </div>
        </div>
        <div className="mt-6 border-t border-slate-100 pt-4 font-mono text-[11px] uppercase tracking-widest text-slate-500">
          © {new Date().getFullYear()} {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
}
